import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Table from "../../../../../../common/components/table";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { useNavigate } from "react-router-dom";
import PageLoader from "../../../../../../components/PageLoader";
import { selectProductionUnitsListItems } from "../../../../../../redux/production-units/selector";
import { productionUnits } from "../../../../../../redux/production-units/action";

const ManagementProductionUnits = () => {
	const dispatch = useAppDispatch()
  const navigate = useNavigate()
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
  const [pageData, setPageData] = useState(1)
    const productionUnitItems = useSelector(selectProductionUnitsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'ProductionUnitInfo.Name', headerName: 'Name' },
      { field: 'ProductionUnitInfo.Description', headerName: 'Description' },
      { field: 'ProductionUnitInfo.PhoneNumber', headerName: 'PhoneNumber' },
      { field: 'ProductionUnitInfo.Email', headerName: 'Email' },
      { field: 'ProductionUnitInfo.SslEnabled', headerName: 'SslEnabled', cellRenderer: 'yesNoRenderer' },
      { field: 'ProductionUnitInfo.IsActive', headerName: 'Active', cellRenderer: 'yesNoRenderer' }
      
        ]);
      }
      const fetchProductionUnits=()=>{

        dispatch(productionUnits.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/production-units/list`,entity:'productionUnits',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
       
      }
	useEffect(() => {
        createColumnDefs()
        fetchProductionUnits()
	}, [pageData])

  const additionButtons: any = [
    {
      name: 'Add ProductionUnits',
      callback: () => handleAdd(),
    },
    {
      name: 'Go To ProductionPlants',
      callback: () => handleProductionUnits(),
    }
  ];
  const handleAdd=()=>{
    navigate(`${0}`)
  }
  const handleProductionUnits=()=>{
    navigate('/management/organization/organization-management/production-plants')
  }
  const handleEdit=(data: any)=>{
    navigate(`${data?.ProductionUnitInfo?.Id}`)
  }
  const handleDelete=(data: any)=>{
    dispatch(productionUnits.delete({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/production-units/delete`,
      entity: 'productionUnits',
      jsonData: {
          Records: [
              {
                  Id: data?.Id
              }
          ]
      }
  })).then(() => {
    dispatch(productionUnits.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/production-units/list`,entity:'productionUnits',jsonData:{
          "PageNumber": pageData,
             "PageSize": 10,
             "SortField": "Id",
             "SortOrder": "desc",}
         }));
  });
  } 
	return (
    <>
    {productionUnitItems?.isLoading ? 
    <PageLoader />
:   
		<Table columnData={columnDefs} rowData={productionUnitItems?.result?.items} setPageData={setPageData}
    paginationData={productionUnitItems?.result?.pagination} onEdit={handleEdit} onDelete={handleDelete} additionButtons={additionButtons} headingName="Production Units"  />
  }
  </> 
     
	);
};

export default ManagementProductionUnits;


